// dropdownHelpers.js

export const handleDropDowns = ({
  key = "",
  itemCodes = [],
  shapes = [],
  colors = [],
  sizes = [],
  settingTypes = [],
  stonesData = [],
  stoneName = "",
  vendors = [],
  customers = [],
  quotations = [],
  categories = [],
  products = [],
  category = [],
  product = [],
  designs = [],
  purities = [],
  branches = [],
  counters = [],        // ALL counters list
  branch = null,        // 👈 CURRENTLY SELECTED BRANCH (object / {_id} / {value} / id string)
  employees = []
}) => {
  if (key === "vendor")            return vendorOptions(vendors);
  if (key === "customer")          return customerOptions(customers);
  if (key === "quotationNumber")   return quotationOptions(quotations);
  if (key === "category")          return categoryOptions(categories);
  if (key === "product")           return productOptions(products, category);
  if (key === "design")            return designOptions(designs, product);
  if (key === "purity")            return puritiesOptions(purities, category);
  if (key === "branch")            return branchOptions(branches);
  if (key === "stoneName")         return stoneOptions(stonesData);
  if (key === "shapeName")         return shapeOptions(shapes);
  if (key === "colorName")         return colorOptions(colors);
  if (key === "sizeName")          return sizeOptions(sizes);
  if (key === "settingTypeName")   return sTypeOptions(settingTypes);
  if (key === "stnUnit")           return [{ value: "gram", label: "gram" }, { value: "carat", label: "carat" }];
  if (key === "itemCodeDetail")    return itemCodeOptions(itemCodes);
  if (key === "soldBy")    return employeeOptions(employees);

  // 🔥 COUNTER: show only when a branch is selected, and filter by that branch
  if (key === "counter")           return counterOptionsFiltered(counters, branch);

  return [];
};

/* ---------- helpers ---------- */

// tolerant id getter for objects/strings
const getId = (x) => (x && (x._id ?? x.value ?? x)) ?? null;
const sameId = (a, b) => String(getId(a) ?? "") === String(getId(b) ?? "");

/* ---------- option builders ---------- */

export const employeeOptions = (employees) => {
  const arr = [];
  employees?.forEach((item) => {
    arr.push({ value: item?._id, label: `${item?.employeeCode}` });
  });
  return arr;
};

export const itemCodeOptions = (itemCodes) => {
  const arr = [];
  itemCodes?.forEach((item) => {
    arr.push({ value: item?._id, label: `${item?.itemCode}${item?.rfidCode ? ` / ${item?.rfidCode}`:""}`, info: item });
  });
  return arr;
};
export const stoneOptions = (stonesData) => {
  const arr = [];
  stonesData?.forEach((item) => {
    arr.push({ value: item?._id, label: item?.stoneName, info: item });
  });
  return arr;
};

export const shapeOptions = (shapes) => {
  const arr = [];
  shapes?.forEach((item) => {
    arr.push({ value: item?._id, label: item?.name });
  });
  return arr;
};

export const colorOptions = (colors) => {
  const arr = [];
  colors?.forEach((item) => {
    arr.push({ value: item?._id, label: item?.name });
  });
  return arr;
};

export const sizeOptions = (sizes) => {
  const arr = [];
  sizes?.forEach((item) => {
    arr.push({ value: item?._id, label: item?.name });
  });
  return arr;
};

export const sTypeOptions = (settingTypes) => {
  const arr = [];
  settingTypes?.forEach((item) => {
    arr.push({ value: item?._id, label: item?.name });
  });
  return arr;
};

export const productOptions = (products, category) => {
  const arr = [];
  const catId = getId(category);
  products?.forEach((prod) => {
    if (sameId(prod?.categoryId, catId)) {
      arr.push({ label: prod?.productName, value: prod?._id });
    }
  });
  return arr;
};

export const designOptions = (designs, product) => {
  const arr = [];
  const prodId = getId(product);
  designs?.forEach((d) => {
    if (sameId(d?.productId, prodId)) {
      arr.push({ label: d?.design, value: d?._id });
    }
  });
  return arr;
};

export const vendorOptions = (vendors) =>
  vendors?.map((v) => ({
    label: v?.vendorName,
    value: v?._id,
    info: v,
  }));

export const customerOptions = (customers) =>
  customers?.map((c) => ({
    label: c?.customerId,
    value: c?._id,
    info: c,
  }));
  export const quotationOptions = (quotations) =>
  quotations?.map((c) => ({
    label: c?.qtnCode,
    value: c?._id,
    info: c,
  }));

export const categoryOptions = (categories) =>
  categories?.map((c) => ({
    label: c?.name,
    value: c?._id,
  }));

export const puritiesOptions = (purities, category) => {
  const arr = [];
  const catId = getId(category);
  purities?.forEach((p) => {
    if (sameId(p?.categoryId, catId)) {
      arr.push({ label: p?.purity, value: p?._id });
    }
  });
  return arr;
};

export const branchOptions = (branches) =>
  branches?.map((b) => ({
    label: b?.branchName,
    value: b?._id,
  }));

// All counters (unfiltered) — not used directly for UI now
export const counterOptions = (counters) =>
  counters?.map((c) => ({
    label: c?.counterName,
    value: c?._id,
  }));

// ✅ Only counters of the selected branch; if branch not selected => []
export const counterOptionsFiltered = (counters, selectedBranch) => {
  const bId = getId(selectedBranch);
  if (!bId) return []; // branch not selected => show nothing
  return counters
    ?.filter((c) =>
      // support both shapes: c.branchId = '...' OR c.branchId = {_id:'...'} OR c.branch = {_id:'...'}
      sameId(c?.branchId ?? c?.branch, bId)
    )
    .map((c) => ({
      label: c?.counterName,
      value: c?._id,
      info: c,
    }));
};
